import { fromJS } from 'immutable';
import { REGISTER_REFERRER, REGISTER_REFERRER_SUCCESS, REGISTER_REFERRER_FAILURE } from './constants';

export const initialState = fromJS({
	loading: false,
	error: '',
	success: false,
});

function referrerSignUpReducer(state = initialState, action) {
	switch (action.type) {
		case REGISTER_REFERRER:
			return state.set('loading', true).set('error', '').set('success', false);
		case REGISTER_REFERRER_SUCCESS:
			return state.set('loading', false).set('success', true);
		case REGISTER_REFERRER_FAILURE:
			return state.set('loading', false).set('error', action.error);
		default:
			return state;
	}
}

export default referrerSignUpReducer;
